import { render, staticRenderFns } from "./jcOrderPoolList.vue?vue&type=template&id=8ef36952&scoped=true"
import script from "./jcOrderPoolList.vue?vue&type=script&lang=js"
export * from "./jcOrderPoolList.vue?vue&type=script&lang=js"
import style0 from "./jcOrderPoolList.vue?vue&type=style&index=0&id=8ef36952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef36952",
  null
  
)

export default component.exports